import React from 'react';
import './Unauthorized.css';
import {useNavigate} from 'react-router-dom';
const Unauthorized = () => {
    const navigate = useNavigate();
    const handleReturn = () => {
        // Implement logic to handle "Return to Home" action
        navigate('/');
    };

    return (
        <div className="unauthorized-container">
            <div className="unauthorized-icon">🚫</div>
            <h3 className="unauthorized-heading">Unauthorized</h3>
            <p className="unauthorized-text">You are not authorized to access the page you requested. Please contact your admin.</p>
            <p className="unauthorized-text">Copyright © IQVIA. All rights reserved</p>
            <button className="return-button" onClick={handleReturn}>Return to Home</button>
        </div>
    );
};

export default Unauthorized;